import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { JiraServiceManagementLogo } from "@atlaskit/logo";
import UFOSegment from "@atlaskit/react-ufo/segment";
import { token } from "@atlaskit/tokens";

import { SignupBackgroundLayout } from "@/components/signup/layouts/signup-background-layout";
import { SiteActivation } from "@/components/signup/site-activation/site-activation";

import { CreateASiteHeading } from "../../../components/create-a-site-heading";

export const LoggedInJsmNewUser = () => {
    return <LoggedInTemplateJsmNewUser />;
};

export const LoggedInTemplateJsmNewUser = () => {
    const intl = useIntl();

    const subHeaderText = intl.formatMessage({
        id: "siteActivation.loggedInJiraServiceManagement.newUser",
        defaultMessage:
            "Sites are the shared space where people organize teams, work, and projects."
    });

    return (
        <UFOSegment name="gwp6480-site-activation">
            <SignupBackgroundLayout
                ProductLogo={
                    <JiraServiceManagementLogo
                        size="xlarge"
                        appearance="brand"
                    />
                }
            >
                <div css={containerCss}>
                    <div css={headerGroupCss}>
                        <h1 css={headerCss}>
                            <span css={accentImageSpanCss}>
                                <CreateASiteHeading />
                            </span>
                        </h1>
                        <p css={headerCss}>{subHeaderText}</p>
                    </div>
                    <SiteActivation />
                </div>
            </SignupBackgroundLayout>
        </UFOSegment>
    );
};

const containerCss = css({
    display: "flex",
    flexDirection: "column"
});

const headerGroupCss = css({
    display: "grid",
    gap: token("space.100")
});

const headerCss = css({
    margin: 0,
    textAlign: "center"
});

const accentImageSpanCss = css({
    position: "relative"
});
